import { Casino, ConfirmationNumber } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { BusinessType } from "@framework/types";
import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

const data = [
  { text: "pages.lottery.title", link: "/lottery/contracts", icon: <Casino /> },
  { text: "pages.lottery.tokens.title", link: "/lottery/ticket/tokens", icon: <ConfirmationNumber /> },
];

export const LotterySection = () => {
  if (process.env.BUSINESS_TYPE === BusinessType.B2B) {
    return null;
  }

  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.lottery" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </StyledPaper>
  );
};
